import { createContext, useContext, useState } from "react";
import en from "./en.json";

// Add "hi": hiJson here when Hindi content is ready.
export const locales = { en };

const LocaleContext = createContext({ locale: "en", t: en, setLocale: () => {} });

export const LocaleProvider = ({ children, initial = "en" }) => {
  const [locale, setLocale] = useState(initial);
  return (
    <LocaleContext.Provider value={{ locale, t: locales[locale] || en, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useContent = () => useContext(LocaleContext);
